'use client';
var removeNonBreakingSpaces = function(text) {
    return text.replace(/&nbsp;/g, "");
};

export { removeNonBreakingSpaces };
